import { render, staticRenderFns } from "./navbar-admin-edit.vue?vue&type=template&id=ddc0874c"
import script from "./navbar-admin-edit.vue?vue&type=script&lang=js"
export * from "./navbar-admin-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports